import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-right', 'IconArrowRight', [
  ['path', { d: 'M5 12l14 0', key: 'svg-0' }],
  ['path', { d: 'M13 18l6 -6', key: 'svg-1' }],
  ['path', { d: 'M13 6l6 6', key: 'svg-2' }],
]);
